// src/components/Billing/Styles/PlansHome.Style.js
// @flow

import { FOOTER_HEIGHT } from '../../PublicCpts/Styles/PublicFooter.Style';

export const IMG_WIDTH = 350;

export const CHECKOUT_PAPER = {
  borderRadius: 0,
  margin: '0 auto',
  marginBottom: 24,
  minWidth: 400,
  maxWidth: 800,
  minHeight: 200,
  paddingBottom: 24
};

const plansHomeStyles = {
  root: (theme) => ({
    minHeight: '100vh',
    display: 'flex',
    maxWidth: '1400px',
    margin: '0 auto'
  }),
  contentCtr: (theme) => ({
    flexGrow: 1,
    marginTop: 70,
    textAlign: 'center'
  }),
  yearlyToggle: (theme) => ({
    '& label': {
      flexWrap: 'nowrap'
    },
    margin: '0 auto',
    width: 'auto',
    display: 'inline-block'
  }),
  paymentFormPaper: (theme) => ({
    ...CHECKOUT_PAPER,
    '& h2': {
      color: theme.palette.primary.main,
      fontSize: '2rem',
      paddingBottom: 0
    },
    '& h3': {
      fontSize: '1.8rem',
      fontWeight: 400
    },
    '& .discountedPrice h3': {
      fontSize: '1.8rem',
      fontWeight: 400,
      marginBottom: 0
    },
    '& .discountedPrice h4': {
      fontSize: '1rem',
      fontWeight: 400,
      marginTop: 0,
      color: 'hsl(0,0%,40%)'
    }
  }),
  striked: (theme) => ({
    textDecoration: 'line-through'
  }),
  featuresList: (theme) => ({
    textAlign: 'center'
  }),
  featureItem: (theme) => ({
    width: '100%',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.border.color}`,
    '&.last': {
      borderBottom: 0
    }
  }),
  buy: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  topBuy: (theme) => ({
    marginTop: -theme.spacing(1),
    marginBottom: theme.spacing(3)
  })
};

export default plansHomeStyles;